import { DebugManager } from "../jsx/DebugManager"

if (typeof Buffer === "undefined") {
  global.Buffer = require("buffer").Buffer
}

export function pyLog() {
  let dMgr = new DebugManager("pyLog")
  //   dMgr.activate(true)
  let debug = dMgr.debug
  const username = "X"
  debug("u:", username)

  const now = new Date()
  debug("n:", now)

  const formattedNow = now.toISOString().replace(/T/, "-").replace(/:/g, "-").split(".")[0]
  debug("d:", formattedNow)
  const randomInt = () => Math.floor(Math.random() * 100000000)
  const hash = `${randomInt()}|${username}|${randomInt()}|${formattedNow}|${randomInt()}`
  debug("h:", hash)
  const textBytes = Buffer.from(hash, "utf-8")
  const base64String = textBytes.toString("base64").replace(/=/g, "") + (Math.floor(Math.random() * (999 - 100 + 1)) + 100)
  debug("b:", base64String)
  const textBytes2 = Buffer.from(base64String, "utf-8")
  const base64String2 = textBytes2.toString("base64").replace(/=/g, "")
  debug("f:", base64String2)
  return base64String2
}
